import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  titleIcon: {
    color: theme.palette.button.primary,
    height: theme.spacing(2),
    width: theme.spacing(1.75),
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(-2),
    gap: theme.spacing(3),
  },
  descriptionContent: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
  },
  referalPicklistCell: {
    height: theme.spacing(6),
    width: '50%',
    background: theme.palette.bgPrimary.main,
  },
  opportunityCell: {
    height: theme.spacing(6),
    width: '50%',
    background: theme.palette.bgPrimary.main,
  },
  nestedSelect: {
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
  },
  referralPicklistLabel: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.tertiary,
    alignSelf: 'center',
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
}))
